/**
 * 翻译字典入口
 * 所有模块的翻译集中导出
 */

import { common } from './common';
import { navigation } from './navigation';
import { auth } from './auth';
import { agent } from './agent';
import { feed } from './feed';
import { agentHomepage } from './agentHomepage';
import { plaza } from './plaza';
import { messages } from './messages';
import { notifications } from './notifications';
import { search } from './search';
import { post } from './post';
import { agentChat } from './agentChat';
import { circles } from './circles';
import { membership } from './membership';
import { legal } from './legal';
import { settings } from './settings';
import { help } from './help';
import { activities } from './activities';
import { report, block } from './report';
import { suspended } from './suspended';
import { account } from './account';
import { creatorSubscription } from './creatorSubscription';
import { tip } from './tip';
import { adminTips } from './adminTips';
import type { TranslationDict, ActiveLanguage } from '../types';

// 合并所有翻译模块
const allTranslations = {
  common,
  navigation,
  auth,
  agent,
  feed,
  agentHomepage,
  plaza,
  messages,
  notifications,
  search,
  post,
  agentChat,
  circles,
  membership,
  legal,
  settings,
  help,
  activities,
  report,
  block,
  suspended,
  account,
  creatorSubscription,
  tip,
  adminTips,
};

// 扁平化翻译结构，生成 { key: { en, zh-CN, ja } }
export type TranslationKey = string;

function flattenTranslations(
  obj: TranslationDict,
  prefix = ''
): Record<string, Record<ActiveLanguage, string>> {
  const result: Record<string, Record<ActiveLanguage, string>> = {};
  
  for (const [key, value] of Object.entries(obj)) {
    const fullKey = prefix ? `${prefix}.${key}` : key;
    
    if (typeof value === 'object' && value !== null) {
      // 检查是否是语言对象（有 en/zh-CN/ja 属性）
      if ('en' in value && typeof value.en === 'string') {
        result[fullKey] = value as Record<ActiveLanguage, string>;
      } else {
        // 嵌套对象，递归处理
        Object.assign(result, flattenTranslations(value as TranslationDict, fullKey));
      }
    }
  }
  
  return result;
}

// 导出扁平化的翻译字典
export const translations = (() => {
  const flat: Record<string, Record<ActiveLanguage, string>> = {};
  
  for (const [module, dict] of Object.entries(allTranslations)) {
    Object.assign(flat, flattenTranslations(dict, module));
  }
  
  return flat;
})();

// 调试：打印所有可用的翻译 key
// console.log('Available translations:', Object.keys(translations));
